// extracted by mini-css-extract-plugin
module.exports = {"scroll":"ScrollDown_scroll__1rq4o","fade_move_down":"ScrollDown_fade_move_down__1YmWz","scroll_wrap":"ScrollDown_scroll_wrap__20hU-"};